import { useLocation } from 'react-router-dom';
import { useProjectSiteNavigation } from '@/shared/lib';
import type { NavigationItemWithState } from '@/entities/navigation';

export const useNavigationItem = (item: NavigationItemWithState) => {
  const { navigateWithContext, buildPath } = useProjectSiteNavigation();
  const location = useLocation();

  const hasSubItems = !!(item.subItems && item.subItems.length > 0);
  const currentPath = item.path ? buildPath(item.path) : '';
  const isCurrentPath = currentPath === location.pathname;
  const isActive = item.isActive || isCurrentPath;

  const handleClick = (onToggle: (code: string) => void) => {
    if (hasSubItems) {
      onToggle(item.code);
    } else if (item.path) {
      navigateWithContext(item.path);
    }
  };

  return {
    hasSubItems,
    isActive,
    isExpanded: item.isExpanded,
    handleClick
  };
};
